import { store } from '@/config/store';
import { selectedTenantFor } from '@/utils/selectedTenant';
import { storeDispatch } from '@/utils/store';

export const isCustomerInfoAffiliateStale = (
  shoppingAffiliateId: number,
  loadedAffiliateId: number | null,
): boolean =>
  shoppingAffiliateId > 0 &&
  loadedAffiliateId !== shoppingAffiliateId;

export const refreshCustomerInfoForAffiliate = async (
  refetch: () => Promise<unknown>,
  customerId: number,
  affiliateId: number,
): Promise<boolean | null> => {
  let requestSucceeded = true;
  try {
    requestSucceeded = (await refetch()) !== false;
  } catch (error) {
    console.error(error);
    requestSucceeded = false;
  }

  // 再取得中に顧客または切り替え先が変わった場合、古い要求から解除しない。
  if (store.state.authInfo.m_customer_id !== customerId) return null;
  const tenant = selectedTenantFor(customerId);
  const currentAffiliateId =
    tenant?.m_affiliate_id ?? store.state.customerInfo.m_affiliate_id;
  if (currentAffiliateId !== affiliateId) return null;
  if (store.state.customerInfoAffiliateId === affiliateId) return true;
  // 通信失敗時は選択を保持し、Home の再試行画面から復旧できるようにする。
  if (!requestSucceeded) return false;
  if (
    tenant?.m_affiliate_id === affiliateId &&
    store.state.customerInfoAffiliateId !== affiliateId
  ) {
    await storeDispatch('setSelectedTenant', 'selectedTenant', null);
  }

  return store.state.customerInfoAffiliateId === affiliateId;
};
